const baseUrl = process.env.VUE_APP_DOMAIN || "https://video-quest-dev.herokuapp.com/";

export const scriptString = `<script type="text/javascript" src="${baseUrl}test.js"></script>`

export const widgetString = (input) => {
  console.log(input)
  return Input;
}